import Date from '@service-victoria/component-library/components/Date';
import Input from '@service-victoria/component-library/components/Input';
import { FieldArray } from 'formik';
import { Identity } from 'interfaces/common';
import React from 'react';
import * as Styled from '../styled';

type Props = {
  identity: Identity;
};

export default function ProofTypePicker({ identity: { proofType } }: Props) {
  let render;

  switch (proofType) {
    case 'driver_license':
      render = (
        <Styled.Wrapper>
          <Input name='identity.givenName' label='Given name on driver licence' />
          <Styled.Spacer24 />
          <Input name='identity.middleName' label='Middle initial on driver licence' />
          <Styled.Spacer24 />
          <Input name='identity.familyName' label='Family name on driver licence' />
          <Styled.Spacer24 />
          <Date name='identity.dob' label='Birth date' />
          <Styled.Spacer24 />
          <Input name='identity.cardNo' label='Victorian driver licence number' />
        </Styled.Wrapper>
      );
      break;
    case 'proofOfAgeCard':
      render = (
        <Styled.Wrapper>
          <Input name='identity.givenName' label='Given name on proof of age card' />
          <Styled.Spacer24 />
          <Input name='identity.familyName' label='Family name on proof of age card' />
          <Styled.Spacer24 />
          <Date name='identity.dob' label='Birth date' />
          <Styled.Spacer24 />
          <Input name='identity.cardNo' label='Victorian proof of age card number' />
        </Styled.Wrapper>
      );
      break;
    case 'seniorsCard':
      render = (
        <Styled.Wrapper>
          <Input name='identity.givenName' label='Given name on seniors card' />
          <Styled.Spacer24 />
          <Input name='identity.familyName' label='Family name on seniors card' />
          <Styled.Spacer24 />
          <Date name='identity.dob' label='Birth date' />
          <Styled.Spacer24 />
          <Input name='identity.cardNo' label='Victorian seniors card number' />
        </Styled.Wrapper>
      );
      break;
    default:
      return null;
  }
  return <FieldArray name='identity' render={() => render} />;
}
